import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
//
import { MyCommonModule } from '../../shared/modules/my-common/my-common.module';
import { UiModule } from '../../shared/modules/ui/ui.module';
import { DocumentModule } from '../document/document.module';
import { DlgEmployeeDocumentGridComponent } from '../employee/components/dlg-employee-document-grid/dlg-employee-document-grid.component';
import { DlgManifestGridComponent } from './components/dlg-manifest-grid/dlg-manifest-grid.component';
import { ScheduleFormComponent } from './components/schedule-form/schedule-form.component';
import { ScheduleGridComponent } from './components/schedule-grid/schedule-grid.component';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { ScheduleComponent } from './containers/schedule/schedule.component';
import { MtmTripsComponent } from './components/mtm-trips/mtm-trips.component';
import { DxToastModule } from 'devextreme-angular';
import { DlgAddEmployeeBackupComponent } from './components/dlg-add-employee-backup/dlg-add-employee-backup.component';
import { DlgCalendarComponent } from './components/dlg-calendar/dlg-calendar.component';
import { DlgScheduleHistoryGridComponent } from './components/dlg-schedule-history-grid/dlg-schedule-history-grid.component';
import { DlgSendSchedulesComponent } from './components/dlg-send-schedules/dlg-send-schedules.component';
import { ScheduleComCenterComponent } from './components/schedule-сom-сenter/schedule-сom-сenter.component';
import { ComCenterComponent } from '../com-center/com-center.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MyCommonModule, UiModule, DxToastModule],
  declarations: [
    ComCenterComponent,
    ScheduleComponent,
    ScheduleListComponent,
    ScheduleGridComponent,
    ScheduleFormComponent,
    ScheduleComCenterComponent,
    MtmTripsComponent,
    DlgManifestGridComponent,
    DlgSendSchedulesComponent,
    DlgScheduleHistoryGridComponent,
    DlgAddEmployeeBackupComponent,
    DlgCalendarComponent,
  ],
  exports: [ScheduleComponent, ScheduleComCenterComponent],
  entryComponents: [
    ScheduleComponent,
    ScheduleComCenterComponent,
    DlgEmployeeDocumentGridComponent,
    ScheduleFormComponent,
    DlgManifestGridComponent,
    DlgSendSchedulesComponent,
    DlgScheduleHistoryGridComponent,
    DlgAddEmployeeBackupComponent,
    DlgCalendarComponent,
  ],
})
export class ScheduleModule {}

